import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJava,
  DiPython,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiHtml5,
  DiCss3,
  DiGit,
  DiAngularSimple,
} from "react-icons/di";
import {
  SiSpring,
  SiFlask
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="Java">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Python">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="JavaScript">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="HTML">
        <DiHtml5 />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="CSS">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="React Js">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Angular">
        <DiAngularSimple />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Node Js">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Spring Boot">
        <SiSpring />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Flask">
        <SiFlask />
      </Col>
  
    </Row>
  );
}

export default Techstack;
